import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaveform = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 118,
	height: 24,
	viewBox: "0 0 118 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 8.4,
			width: 4,
			height: 7.2,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 6,
			width: 4,
			height: 12,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 2.4,
			width: 4,
			height: 19.2,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 7.2,
			width: 4,
			height: 9.6,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 1.2,
			width: 4,
			height: 21.6,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 30,
			y: 4.8,
			width: 4,
			height: 14.4,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36,
			y: 0,
			width: 4,
			height: 24,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42,
			y: 6,
			width: 4,
			height: 12,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 48,
			y: 3.6,
			width: 4,
			height: 16.8,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 54,
			y: 8.4,
			width: 4,
			height: 7.2,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 60,
			y: 2.4,
			width: 4,
			height: 19.2,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 66,
			y: 4.8,
			width: 4,
			height: 14.4,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 72,
			y: 1.2,
			width: 4,
			height: 21.6,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 78,
			y: 7.2,
			width: 4,
			height: 9.6,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84,
			y: 4.8,
			width: 4,
			height: 14.4,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 90,
			y: 8.4,
			width: 4,
			height: 7.2,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96,
			y: 6,
			width: 4,
			height: 12,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102,
			y: 3.6,
			width: 4,
			height: 16.8,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 108,
			y: 7.2,
			width: 4,
			height: 9.6,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 114,
			y: 9.6,
			width: 4,
			height: 4.8,
			rx: 2,
			fill: "currentColor"
		})
	]
});
export default SvgWaveform;
